import { render, staticRenderFns } from "./newSkiLand.vue?vue&type=template&id=0b978994&scoped=true&"
import script from "./newSkiLand.vue?vue&type=script&lang=js&"
export * from "./newSkiLand.vue?vue&type=script&lang=js&"
import style0 from "./newSkiLand.vue?vue&type=style&index=0&id=0b978994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b978994",
  null
  
)

export default component.exports